import { GetPriceChartResponse } from '@blockworks/platform/api/coingecko';

const selectPriceList = (data: GetPriceChartResponse) => {
    return data.prices.map(([date, price]) => ({
        date,
        price,
    }));
};

export { selectPriceList };
